import { Box, formatMoney, NonGradientTextTokens } from '@betty/moonlight';
import { memo, useMemo } from 'react';
import SessionHistoryListItemRow from '../SessionHistoryListItemRow/SessionHistoryListItemRow';
import { SessionItem } from '../../state/sessionHistory/sessionHistory.types';
import { formatDate, SHORT_DATE, SHORT_TIME } from '@betty/toolkit/utils';

function SessionHistoryListItem({
  loginDateTime,
  logoutDateTime,
  loginBalance,
  logoutBalance,
  totalBets,
  totalWins,
  netPosition,
}: SessionItem) {
  const { netAmount, netColor } = useMemo((): {
    netAmount: string;
    netColor?: NonGradientTextTokens;
  } => {
    if (netPosition === undefined) {
      return {
        netAmount: '---',
      };
    }

    const money = formatMoney(netPosition);

    if (netPosition > 0) {
      return { netAmount: `+${money}`, netColor: 'darkSurfaceSuccess' };
    }

    if (netPosition < 0) {
      return { netAmount: money, netColor: 'darkSurfaceError' };
    }

    return { netAmount: money };
  }, [netPosition]);

  return (
    <Box gap="space-300">
      <SessionHistoryListItemRow
        labelKey="sessionLogin"
        valueA={formatDate(loginDateTime, SHORT_DATE)}
        valueB={formatDate(loginDateTime, SHORT_TIME)}
      />
      <SessionHistoryListItemRow
        labelKey="sessionLogout"
        valueA={logoutDateTime ? formatDate(logoutDateTime, SHORT_DATE) : '---'}
        valueB={logoutDateTime ? formatDate(logoutDateTime, SHORT_TIME) : '---'}
      />
      <SessionHistoryListItemRow
        labelKey="sessionLoginBalance"
        valueA={formatMoney(loginBalance)}
      />
      <SessionHistoryListItemRow
        labelKey="sessionLogoutBalance"
        valueA={formatMoney(logoutBalance)}
      />
      <SessionHistoryListItemRow
        labelKey="sessionTotalBets"
        valueA={formatMoney(totalBets)}
      />
      <SessionHistoryListItemRow
        labelKey="sessionTotalWins"
        valueA={formatMoney(totalWins)}
      />
      <SessionHistoryListItemRow
        labelKey="sessionNetGaming"
        valueA={netAmount}
        valueAColor={netColor}
        accent
      />
    </Box>
  );
}

export default memo(SessionHistoryListItem);
